/*! Ardor Designer Kit v1 (Oct 18, 2026) - Ardor Printing, ardorprinting.com
 * Adds to the banner designer: Templates, Add heading / subheading / body text, Text suggestions, Quick text,
 * an always-available Background panel with a gallery, and a QR code tool.
 * Talks to the designer only through window.ArdorBannerLayers.kit (assets/ardor-banner-ai-layers-kit.js) and
 * window.ArdorBannerAPI. Heavy parts load on first use from window.ArdorKitAssets: bg (ArdorBG), data (ArdorTPLData),
 * tpl (ArdorTPL), qr (ArdorQR). Print files are unchanged: every new item is an ordinary layer that the designer
 * flattens into the print file and paints on the 3D view and the proof, exactly like text and clipart.
 */
(function () {
  'use strict';
  if (window.ArdorDesignerKit) return;

  var K = null, API = null, fabric = null, fc = null, booted = false, uiReady = false;
  var ASSETS = window.ArdorKitAssets || {};
  var loaded = {}, loading = {};
  var st = { info: { business: '', phone: '', web: '' }, tpl: null, tplFace: null, tplVar: '', tplDirty: false, suggCat: '', tplCat: '', bgCat: 'Solid', thumbs: {}, thumbKey: '', qrEdit: null, rebuilding: false };
  var FONT_PRE = ['Anton', 'Jost', 'Bebas Neue', 'Unbounded', 'Rubik Mono One', 'Pacifico', 'Monoton', 'Satisfy', 'Bree Serif', 'Bangers', 'Quicksand', 'Permanent Marker', 'Black Ops One', 'Righteous', 'Lobster'];

  // ---------- helpers ----------
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function phone() { try { return window.matchMedia('(max-width: 900px)').matches; } catch (e) { return window.innerWidth <= 900; } }
  function toast(m, ms, act) { try { K.toast(m, ms || 4000, act); } catch (e) {} }
  function track(k) { try { (window.dataLayer = window.dataLayer || []).push({ event: 'ardor_kit_' + k }); } catch (e) {} }
  function lsGet(k) { try { return JSON.parse(window.localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function failed(e) { try { console.warn('[ardor kit]', e); } catch (x) {} toast('That tool could not load. Please refresh the page and try again.', 6000); }

  function load(name) {
    var glob = { bg: 'ArdorBG', data: 'ArdorTPLData', tpl: 'ArdorTPL', qr: 'ArdorQR' }[name];
    if (glob && window[glob]) return Promise.resolve(window[glob]);
    if (loading[name]) return loading[name];
    loading[name] = new Promise(function (res, rej) {
      var src = ASSETS[name];
      if (!src) { rej(new Error('no asset url for ' + name)); return; }
      var s = document.createElement('script'); s.src = src; s.async = true;
      s.onload = function () { loaded[name] = true; if (window[glob]) res(window[glob]); else rej(new Error(name)); };
      s.onerror = function () { loading[name] = null; rej(new Error('load ' + name)); };
      document.head.appendChild(s);
    });
    return loading[name];
  }
  function loadTpl() { return load('data').then(function () { return load('tpl'); }); }

  function cfgSize() { var b = K.banner(); return { b: b, Wi: b.Wi, Hi: b.Hi, safe: K.safeArea(b.c, b.Wi, b.Hi) }; }
  function canvas() { fc = K.canvas(); return fc; }
  function curFace() { return K.face(); }
  function objs() { return canvas() ? fc.getObjects() : []; }
  function bgObj() { var o = objs().filter(function (x) { return x.ablKind === 'bg'; }); return o[0] || null; }
  function faceArt(f) { try { return API.getArt(f || curFace()); } catch (e) { return null; } }
  function fontsReady(list) {
    return K.loadFonts().then(function () { return Promise.all(list.map(function (f) { return K.fontReady(f); })); });
  }

  // ---------- custom Fabric classes ----------
  function registerClasses() {
    if (fabric.ArdorBg) return;
    fabric.ArdorBg = fabric.util.createClass(fabric.Object, {
      type: 'ardorBg',
      initialize: function (o) {
        o = o || {};
        this.callSuper('initialize', o);
        this.set({ originX: 'left', originY: 'top', strokeWidth: 0, stroke: null, selectable: false, evented: false, hasControls: false, hasBorders: false, objectCaching: false, ablKind: 'bg' });
        this.ablBg = o.ablBg || { t: 'solid', c: '#FFFFFF' };
      },
      _render: function (ctx) {
        var w = this.width, h = this.height;
        if (window.ArdorBG) { try { window.ArdorBG.draw(ctx, -w / 2, -h / 2, w, h, this.ablBg); return; } catch (e) {} }
        ctx.fillStyle = (this.ablBg && this.ablBg.c) || '#FFFFFF'; ctx.fillRect(-w / 2, -h / 2, w, h);
      }
    });
    fabric.ArdorBg.fromObject = function (o, cb) { var x = new fabric.ArdorBg(o); if (cb) cb(x); return x; };
  }

  // ---------- boot ----------
  function boot() {
    if (booted) return;
    var L = window.ArdorBannerLayers;
    if (!L || !L.kit) return;
    K = L.kit; API = K.api(); booted = true;
    if (K.ui() && K.ui().drawer) buildUi();
    else document.addEventListener('ardor:layers-kit-ui', function () { buildUi(); });
    setInterval(watchSize, 450);
    // load Fabric + the background module early but idle, so undo / restore of backgrounds always works
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 2500); };
    idle(function () { withFabric().catch(function () {}); });
  }
  function withFabric() {
    return K.ready().then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      return load('bg');
    });
  }
  var hooked = false;
  function hookCanvas() {
    if (hooked || !fc) return; hooked = true;
    var sb = fc.sendBackwards, stb = fc.sendToBack;
    fc.sendBackwards = function (o) { var r = sb.apply(fc, arguments); bgBottom(); return r; };
    fc.sendToBack = function (o) { var r = stb.apply(fc, arguments); if (o && o.ablKind !== 'bg') bgBottom(); return r; };
    fc.on('object:added', function () { bgBottom(); if (!st.rebuilding) qtRefreshSoon(); });
    fc.on('object:removed', function () { if (!st.rebuilding) qtRefreshSoon(); });
    fc.on('object:modified', function (e) { if (!st.rebuilding && e && e.target && e.target.ablTpl) st.tplDirty = true; });
    fc.on('text:changed', function (e) { if (e && e.target && e.target.ablTpl) st.tplDirty = true; qtRefreshSoon(true); });
    fc.on('selection:created', selSync); fc.on('selection:updated', selSync); fc.on('selection:cleared', selSync);
    fc.on('after:render', drawGuides);
  }
  // with a full background layer the designer's own guides (safe line, hems, grommets) sit under it: draw them on top
  function drawGuides() {
    if (!fc || !bgObj()) return;
    var c; try { c = API.cfg(); } catch (e) { return; }
    var Wi = c.W * 12, Hi = c.H * 12, v = fc.viewportTransform, rs = fc.getRetinaScaling ? fc.getRetinaScaling() : 1, ctx = fc.getContext();
    if (!ctx || !v) return;
    var P = (c.poleSize || 0) + 0.5, b = { top: c.pole && c.pole !== 'none' ? P : (c.hem ? 1 : 0), bottom: c.pole === 'tb' ? P : (c.hem ? 1 : 0), side: c.hem ? 1 : 0 };
    var lw = Math.max(Wi, Hi) / 600, ins = function (d) { return Math.max(d, 1) + 1; };
    ctx.save();
    ctx.setTransform(v[0] * rs, 0, 0, v[3] * rs, v[4] * rs, v[5] * rs);
    ctx.beginPath(); ctx.rect(0, 0, Wi, Hi); ctx.clip();
    ctx.fillStyle = 'rgba(12,13,13,0.10)';
    if (b.top) ctx.fillRect(0, 0, Wi, b.top);
    if (b.bottom) ctx.fillRect(0, Hi - b.bottom, Wi, b.bottom);
    if (b.side) { ctx.fillRect(0, 0, b.side, Hi); ctx.fillRect(Wi - b.side, 0, b.side, Hi); }
    ctx.setLineDash([lw * 6, lw * 4]); ctx.lineWidth = lw * 1.5; ctx.strokeStyle = 'rgba(255,255,255,0.75)';
    ctx.strokeRect(ins(b.side), ins(b.top), Wi - ins(b.side) * 2, Hi - ins(b.top) - ins(b.bottom));
    ctx.lineDashOffset = lw * 5; ctx.strokeStyle = 'rgba(189,37,44,0.95)';
    ctx.strokeRect(ins(b.side), ins(b.top), Wi - ins(b.side) * 2, Hi - ins(b.top) - ins(b.bottom));
    ctx.setLineDash([]);
    var g = c.grommet, i0 = 0.75, pts = [], seen = {};
    var add = function (x, y) { var k = Math.round(x * 10) + ':' + Math.round(y * 10); if (!seen[k]) { seen[k] = 1; pts.push([x, y]); } };
    var run = function (len) { var n = Math.max(1, Math.ceil((len - 2 * i0) / 24)), a = []; for (var i = 0; i <= n; i++) a.push(i0 + i * (len - 2 * i0) / n); return a; };
    if (!(c.pole && c.pole !== 'none')) {
      if (g === 'all' || g === 'tb') run(Wi).forEach(function (x) { add(x, i0); add(x, Hi - i0); });
      if (g === 'all' || g === 'lr') run(Hi).forEach(function (y) { add(i0, y); add(Wi - i0, y); });
      if (g === 'corners') { add(i0, i0); add(Wi - i0, i0); add(i0, Hi - i0); add(Wi - i0, Hi - i0); }
    }
    pts.forEach(function (p) {
      ctx.beginPath(); ctx.arc(p[0], p[1], 0.55, 0, Math.PI * 2); ctx.fillStyle = '#B9BCBF'; ctx.fill();
      ctx.beginPath(); ctx.arc(p[0], p[1], 0.24, 0, Math.PI * 2); ctx.fillStyle = '#FFFFFF'; ctx.fill();
    });
    ctx.restore();
  }
  function bgBottom() { var b = bgObj(); if (b && fc.getObjects().indexOf(b) > 0) { fc.moveTo(b, 0); fc.requestRenderAll(); } }

  // ---------- UI ----------
  var IC = {
    tpl: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>',
    bg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="m3 16 5-5 4 4 3-3 6 6"/><circle cx="16" cy="9" r="1.6"/></svg>',
    qr: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3h-3zM20 14v.01M14 20h.01M17 20h4v-3"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" width="20" height="20"><path d="M6 6l12 12M18 6 6 18"/></svg>'
  };
  var ui = {};
  function railBtn(name, icon, label) {
    var b = el('button', 'abx-tool abl-tool adk-tool', '<span class="abl-tool-ic" aria-hidden="true">' + icon + '</span><span>' + label + '</span>');
    b.type = 'button'; b.setAttribute('data-abl-tool', name); b.setAttribute('aria-expanded', 'false');
    return b;
  }
  function panel(name, title, body) {
    var p = el('div', 'abl-drawer__panel adk-panel', '<div class="abl-drawer__head"><h2>' + title + '</h2><button type="button" class="abl-x" data-adk-close aria-label="Close">' + IC.x + '</button></div><div class="abl-drawer__body adk-body">' + body + '</div>');
    p.setAttribute('data-abl-panel', name); p.hidden = true;
    $('[data-adk-close]', p).addEventListener('click', function () { K.closeDrawer(); });
    ui.drawer.appendChild(p);
    return p;
  }
  function buildUi() {
    if (uiReady) return;
    var u = K.ui(); if (!u || !u.drawer) return;
    uiReady = true; ui.drawer = u.drawer;
    var rail = document.querySelector('.abx-rail');
    var textBtn = rail && $('[data-abl-tool="text"]', rail), clipBtn = rail && $('[data-abl-tool="clipart"]', rail);
    ui.tTpl = railBtn('templates', IC.tpl, 'Templates');
    ui.tBg = railBtn('background', IC.bg, 'Background');
    ui.tQr = railBtn('qr', IC.qr, 'QR code');
    if (rail && textBtn) {
      rail.insertBefore(ui.tTpl, textBtn);
      var after = clipBtn ? clipBtn.nextSibling : textBtn.nextSibling;
      rail.insertBefore(ui.tBg, after); rail.insertBefore(ui.tQr, ui.tBg.nextSibling);
    } else {
      var host = (textBtn && textBtn.parentNode) || document.querySelector('.abl-minirail');
      if (host) { host.insertBefore(ui.tTpl, host.firstChild); host.appendChild(ui.tBg); host.appendChild(ui.tQr); }
    }
    // the print-template download button keeps working; its label now says what it is
    $$('.abx-rail .abx-tool').forEach(function (b) { var s = b.querySelector('span:last-child'); if (s && /^\s*Template\s*$/.test(s.textContent) && !b.classList.contains('adk-tool')) { s.textContent = 'Print template'; b.title = 'Download a print-ready template for this size (for your own designer)'; } });
    [ui.tTpl, ui.tBg, ui.tQr].forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.getAttribute('data-abl-tool');
        setTimeout(function () { if (n === 'templates') openTemplates(); if (n === 'background') openBackground(); if (n === 'qr') openQr(); }, 0);
      });
    });
    buildTextExtras();
    buildTemplatesPanel();
    buildBgPanel();
    buildQrPanel();
    buildPropsExtras();
    var saved = lsGet('ardorKitInfo'); if (saved) st.info = { business: saved.business || '', phone: saved.phone || '', web: saved.web || '' };
    syncInfoFields();
    // the empty canvas card: offer templates too
    var card = document.querySelector('.abx-empty__card');
    if (card && !card.querySelector('.adk-empty-tpl')) {
      var a = el('button', 'adk-empty-tpl', IC.tpl + ' <span>Start from a <u>ready-made template</u></span>'); a.type = 'button';
      a.addEventListener('click', function () { ui.tTpl.click(); });
      card.appendChild(a);
    }
    if (/[#&?]kit=templates/.test(location.href)) setTimeout(function () { ui.tTpl.click(); }, 600);
    // ?tpl=<template id> (works with ?preset=w:8,h:4): open the designer with that template already on the banner
    var tm = /[#&?]tpl=([a-z0-9-]+)/i.exec(location.href);
    if (tm) setTimeout(function () { loadTpl().then(function () { var it = window.ArdorTPL.get(tm[1]); if (it && !designOnFace()) applyTemplate(it, { reason: 'link' }); }).catch(function () {}); }, /[?&]preset=/.test(location.search) ? 1800 : 700);
  }

  // ---------- Text: presets, suggestions, quick text ----------
  function buildTextExtras() {
    var tp = $('[data-abl-panel="text"]', ui.drawer); if (!tp) return;
    var body = $('.abl-drawer__body', tp);
    var fontsWrap = el('div', 'adk-tabpane', ''); fontsWrap.setAttribute('data-adk-pane', 'fonts');
    while (body.firstChild) fontsWrap.appendChild(body.firstChild);
    var top = el('div', 'adk-text-top',
      '<div class="adk-presets">' +
        '<button type="button" class="adk-preset adk-preset--h" data-adk-preset="h"><b>Add a heading</b></button>' +
        '<button type="button" class="adk-preset adk-preset--s" data-adk-preset="s"><b>Add a subheading</b></button>' +
        '<button type="button" class="adk-preset adk-preset--b" data-adk-preset="b"><b>Add body text</b></button>' +
      '</div>' +
      '<div class="adk-tabs" role="tablist"><button type="button" role="tab" data-adk-tab="sugg" aria-selected="true">Suggestions</button><button type="button" role="tab" data-adk-tab="fonts" aria-selected="false">Fonts</button><button type="button" role="tab" data-adk-tab="quick" aria-selected="false">Quick text</button></div>');
    body.appendChild(top);
    var sugg = el('div', 'adk-tabpane', '<div class="adk-chips" data-adk-sugg-cats></div><div class="adk-grid adk-grid--sugg" data-adk-sugg><p class="abl-help">Loading ideas...</p></div>');
    sugg.setAttribute('data-adk-pane', 'sugg');
    var quick = el('div', 'adk-tabpane', '<p class="abl-help">Every line of text on this side of your banner. Change the words here; the banner updates as you type.</p><div class="adk-quick" data-adk-quick></div>');
    quick.setAttribute('data-adk-pane', 'quick'); quick.hidden = true; fontsWrap.hidden = true;
    body.appendChild(sugg); body.appendChild(fontsWrap); body.appendChild(quick);
    ui.textBody = body; ui.sugg = $('[data-adk-sugg]', sugg); ui.suggCats = $('[data-adk-sugg-cats]', sugg); ui.quick = $('[data-adk-quick]', quick);
    $$('[data-adk-preset]', top).forEach(function (b) { b.addEventListener('click', function () { addPreset(b.getAttribute('data-adk-preset')); }); });
    $$('[data-adk-tab]', top).forEach(function (b) {
      b.addEventListener('click', function () { textTab(b.getAttribute('data-adk-tab')); });
    });
    var textRail = document.querySelector('[data-abl-tool="text"]');
    if (textRail) textRail.addEventListener('click', function () { setTimeout(function () { if (st.textTab === 'sugg' || !st.textTab) renderSuggestions(); if (st.textTab === 'quick') renderQuick(); }, 0); });
    st.textTab = 'sugg';
  }
  function textTab(name) {
    st.textTab = name;
    $$('[data-adk-tab]', ui.textBody).forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-adk-tab') === name ? 'true' : 'false'); });
    $$('[data-adk-pane]', ui.textBody).forEach(function (p) { p.hidden = p.getAttribute('data-adk-pane') !== name; });
    if (name === 'sugg') renderSuggestions();
    if (name === 'quick') renderQuick();
  }
  function addPreset(kind) {
    var fam = kind === 'h' ? 'Anton' : 'Jost';
    K.ready().then(function () { fabric = K.fabric(); canvas(); registerClasses(); hookCanvas(); return fontsReady([fam]); }).then(function () {
      K.targetFace();
      var z = cfgSize(), s = z.safe, b = bgObj(), dark = false;
      try { dark = b && window.ArdorBG ? window.ArdorBG.isDark(b.ablBg) : false; } catch (e) {}
      var H = Math.min(s.h * 0.30, s.w * 0.16);
      var spec = {
        h: { t: 'Add a heading', fs: H, y: s.y + s.h * 0.28, w: s.w * 0.92 },
        s: { t: 'Add a subheading', fs: H * 0.46, y: s.y + s.h * 0.56, w: s.w * 0.86 },
        b: { t: 'Add a little bit of body text', fs: H * 0.26, y: s.y + s.h * 0.78, w: s.w * 0.8 }
      }[kind];
      var t = K.look(new fabric.IText(kind === 'h' ? spec.t.toUpperCase() : spec.t, { fontFamily: fam, fontSize: spec.fs, fill: dark ? '#FFFFFF' : '#16161b', textAlign: 'center', originX: 'center', originY: 'center', left: z.Wi / 2, top: spec.y, paintFirst: 'stroke', strokeLineJoin: 'round', strokeWidth: 0, stroke: null, ablKind: 'text', ablStroke: 0, ablRole: kind === 'h' ? 'headline' : (kind === 's' ? 'sub' : 'detail'), charSpacing: kind === 'h' ? 20 : 0 }));
      if (kind !== 'h' && fam === 'Jost') t.set({ fontWeight: kind === 's' ? '600' : '400' });
      var w = t.getScaledWidth(); if (w > spec.w) t.scale(t.scaleX * spec.w / w);
      // don't land exactly on top of another text
      var tries = 0;
      while (tries++ < 4 && fc.getObjects().some(function (o) { return o !== t && o.ablKind === 'text' && Math.abs(o.top - t.top) < spec.fs * 0.6 && Math.abs(o.left - t.left) < z.Wi * 0.3; })) t.set({ top: clamp(t.top + spec.fs * 1.1, s.y + spec.fs / 2, s.y + s.h - spec.fs / 2) });
      K.fitInside(t, s);
      K.place(t);
      track('text_' + kind);
    }).catch(failed);
  }

  function isDarkFace() { var b = bgObj(); try { if (b && window.ArdorBG) return window.ArdorBG.isDark(b.ablBg); } catch (e) {} return false; }
  function renderSuggestions() {
    if (!ui.sugg) return;
    Promise.all([K.ready(), loadTpl(), load('bg')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      var T = window.ArdorTPL, cats = T.suggestionCategories ? T.suggestionCategories() : [];
      if (!ui.suggCats.children.length) {
        var all = el('button', 'adk-chip', 'All'); all.type = 'button'; all.setAttribute('data-c', ''); ui.suggCats.appendChild(all);
        cats.forEach(function (c) { var n = typeof c === 'string' ? c : (c.name || c.id); var id = typeof c === 'string' ? c : (c.id || c.name); var b = el('button', 'adk-chip', esc(n)); b.type = 'button'; b.setAttribute('data-c', id); ui.suggCats.appendChild(b); });
        ui.suggCats.addEventListener('click', function (e) { var b = e.target.closest('[data-c]'); if (!b) return; st.suggCat = b.getAttribute('data-c'); renderSuggestions(); });
      }
      $$('[data-c]', ui.suggCats).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c') === st.suggCat ? 'true' : 'false'); });
      var items = T.listSuggestions(st.suggCat), dark = isDarkFace();
      return fontsReady(FONT_PRE).then(function () {
        ui.sugg.textContent = '';
        items.forEach(function (it, i) {
          var b = el('button', 'adk-card adk-card--sugg' + (dark ? ' is-dark' : '')); b.type = 'button'; b.title = it.name; b.setAttribute('aria-label', 'Add ' + it.name);
          b.addEventListener('click', function () { addSuggestion(it); });
          ui.sugg.appendChild(b);
          setTimeout(function () { try { b.appendChild(suggThumb(it, dark)); } catch (e) {} }, i * 12);
        });
      });
    }).catch(failed);
  }
  function suggThumb(it, dark) {
    var key = 's|' + it.id + '|' + dark;
    if (st.thumbs[key]) { var im0 = new Image(); im0.src = st.thumbs[key]; im0.alt = ''; return im0; }
    var bw = 50, bh = 22, px = 6;
    var objsT = window.ArdorTPL.buildSuggestion(fabric, it, { x: 1, y: 1, w: bw - 2, h: bh - 2 }, { dark: dark, info: st.info });
    var cv = el('canvas'); var sc = new fabric.StaticCanvas(cv, { width: bw * px, height: bh * px, enableRetinaScaling: false, renderOnAddRemove: false });
    sc.setViewportTransform([px, 0, 0, px, 0, 0]);
    sc.backgroundColor = dark ? '#1d2230' : '#f4f2ec';
    objsT.forEach(function (o) { sc.add(o); });
    sc.renderAll();
    var url = sc.toDataURL({ format: 'png' });
    sc.dispose();
    st.thumbs[key] = url;
    var im = new Image(); im.src = url; im.alt = ''; return im;
  }
  function addSuggestion(it) {
    Promise.all([K.ready(), loadTpl()]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      return fontsReady(window.ArdorTPL.fonts(it));
    }).then(function () {
      K.targetFace();
      var z = cfgSize(), s = z.safe, others = fc.getObjects().filter(function (o) { return o.ablKind !== 'bg'; }).length;
      var bw = others ? s.w * 0.62 : s.w * 0.9, bh = others ? s.h * 0.5 : s.h * 0.8;
      if (s.w / s.h < 1) { bw = s.w * (others ? 0.8 : 0.92); bh = s.h * (others ? 0.38 : 0.6); }
      var box = { x: z.Wi / 2 - bw / 2, y: (s.y + s.h / 2) - bh / 2, w: bw, h: bh };
      var list = window.ArdorTPL.buildSuggestion(fabric, it, box, { dark: isDarkFace(), info: st.info });
      K.setQuiet(true);
      list.forEach(function (o) { K.look(o); o.ablTpl = null; fc.add(o); });
      K.setQuiet(false);
      if (list.length > 1) { var sel = new fabric.ActiveSelection(list, { canvas: fc }); K.look(sel); fc.setActiveObject(sel); }
      else if (list[0]) fc.setActiveObject(list[0]);
      K.changed(true); K.syncProps(); fc.requestRenderAll();
      if (phone()) K.closeDrawer();
      toast('Added. Drag to move it, or tap a line of text to change the words.', 4500);
      track('suggestion');
    }).catch(failed);
  }

  var qtT = 0;
  function qtRefreshSoon(skipFocused) { clearTimeout(qtT); qtT = setTimeout(function () { if (st.textTab === 'quick' && ui.quick && !ui.quick.closest('[hidden]')) renderQuick(skipFocused); }, 120); }
  function renderQuick(skipFocused) {
    if (!ui.quick) return;
    if (skipFocused && ui.quick.contains(document.activeElement)) return;
    var texts = objs().filter(function (o) { return o.ablKind === 'text' || o.type === 'i-text'; });
    ui.quick.textContent = '';
    if (!texts.length) { ui.quick.appendChild(el('p', 'abl-help', 'No text on this side yet. Add a heading, a suggestion or a template first.')); return; }
    texts.forEach(function (o, i) {
      var ta = el('textarea', 'abl-input abl-textarea adk-qt'); ta.rows = Math.min(3, String(o.text).split('\n').length); ta.value = o.text; ta.setAttribute('aria-label', 'Text line ' + (i + 1));
      ta.style.fontFamily = '\'' + o.fontFamily + '\', sans-serif';
      ta.addEventListener('focus', function () { try { fc.setActiveObject(o); fc.requestRenderAll(); K.syncProps(); } catch (e) {} });
      ta.addEventListener('input', function () { o.set('text', ta.value || ' '); if (o.ablStroke) o.set({ strokeWidth: o.fontSize * o.ablStroke * 0.012 }); o.setCoords(); fc.requestRenderAll(); if (o.ablTpl) st.tplDirty = true; try { API.renderArtOnly(); } catch (e) {} });
      ta.addEventListener('change', function () { K.changed(true); K.syncProps(); });
      ui.quick.appendChild(ta);
    });
  }

  // ---------- Templates ----------
  function buildTemplatesPanel() {
    var p = panel('templates', 'Templates',
      '<p class="abl-help">Pick a design and make it yours. Every word, color and shape can be changed, moved or deleted, and the layout fits whatever banner size you choose.</p>' +
      '<details class="adk-info" data-adk-info-box><summary>Fill in your details <small>(optional)</small></summary>' +
        '<label class="adk-field"><span>Business or event name</span><input class="abl-input" data-adk-info="business" maxlength="60" autocomplete="organization"></label>' +
        '<label class="adk-field"><span>Phone</span><input class="abl-input" data-adk-info="phone" maxlength="30" inputmode="tel" autocomplete="tel"></label>' +
        '<label class="adk-field"><span>Website</span><input class="abl-input" data-adk-info="web" maxlength="80" inputmode="url" autocomplete="url"></label>' +
        '<p class="abl-help adk-small">Your details show on every template below. Templates with a QR spot turn your website into a QR code.</p>' +
        '<button type="button" class="adk-btn" data-adk-info-apply hidden>Update my banner with these details</button>' +
      '</details>' +
      '<div class="adk-chips" data-adk-tpl-cats></div>' +
      '<div class="adk-confirm" data-adk-confirm hidden><p>This replaces what is on this side of your banner (you can undo).</p><div><button type="button" class="adk-btn" data-adk-yes>Use this template</button><button type="button" class="adk-btn adk-btn--ghost" data-adk-no>Cancel</button></div></div>' +
      '<div class="adk-grid adk-grid--tpl" data-adk-tpl><p class="abl-help">Loading templates...</p></div>');
    ui.tplPanel = p; ui.tpl = $('[data-adk-tpl]', p); ui.tplCats = $('[data-adk-tpl-cats]', p); ui.confirm = $('[data-adk-confirm]', p);
    $$('[data-adk-info]', p).forEach(function (inp) {
      inp.addEventListener('input', function () {
        st.info[inp.getAttribute('data-adk-info')] = inp.value.replace(/^\s+/, '');
        lsSet('ardorKitInfo', st.info);
        clearTimeout(st.infoT); st.infoT = setTimeout(function () { st.thumbs = {}; renderTemplates(); }, 500);
        var ab = $('[data-adk-info-apply]', p); if (ab) ab.hidden = !(st.tpl && st.tplFace === curFace());
      });
    });
    $('[data-adk-info-apply]', p).addEventListener('click', function () { if (st.tpl) applyTemplate(st.tpl, { keepEdits: true, reason: 'info' }); });
    $('[data-adk-no]', p).addEventListener('click', function () { ui.confirm.hidden = true; st.pending = null; });
    $('[data-adk-yes]', p).addEventListener('click', function () { ui.confirm.hidden = true; if (st.pending) applyTemplate(st.pending, {}); st.pending = null; });
  }
  function syncInfoFields() { if (!ui.tplPanel) return; $$('[data-adk-info]', ui.tplPanel).forEach(function (inp) { inp.value = st.info[inp.getAttribute('data-adk-info')] || ''; }); }
  function openTemplates() { renderTemplates(); }
  function renderTemplates() {
    if (!ui.tpl) return;
    Promise.all([K.ready(), loadTpl(), load('bg'), load('qr')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      var T = window.ArdorTPL, cats = T.categories ? T.categories() : (window.ArdorTPLData.categories || []);
      if (!ui.tplCats.children.length) {
        var all = el('button', 'adk-chip', 'All'); all.type = 'button'; all.setAttribute('data-c', ''); ui.tplCats.appendChild(all);
        cats.forEach(function (c) { var b = el('button', 'adk-chip', esc(c.name || c.id)); b.type = 'button'; b.setAttribute('data-c', c.id || c.name); ui.tplCats.appendChild(b); });
        ui.tplCats.addEventListener('click', function (e) { var b = e.target.closest('[data-c]'); if (!b) return; st.tplCat = b.getAttribute('data-c'); renderTemplates(); });
      }
      $$('[data-c]', ui.tplCats).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c') === st.tplCat ? 'true' : 'false'); });
      return fontsReady(FONT_PRE.concat(['Arial'])).then(function () {
        var z = cfgSize(), key = z.Wi + 'x' + z.Hi + '|' + JSON.stringify(st.info);
        if (st.thumbKey !== key) { st.thumbs = {}; st.thumbKey = key; }
        var items = T.list(st.tplCat);
        ui.tpl.textContent = '';
        ui.tpl.classList.toggle('is-tall', z.Wi / z.Hi < 0.9);
        ui.tpl.classList.toggle('is-xwide', z.Wi / z.Hi >= 3.2);
        items.forEach(function (it, i) {
          var b = el('button', 'adk-card adk-card--tpl'); b.type = 'button'; b.setAttribute('aria-label', 'Use template: ' + it.name);
          b.innerHTML = '<span class="adk-card__img"></span><span class="adk-card__name">' + esc(it.name) + '</span>';
          b.addEventListener('click', function () { chooseTemplate(it); });
          ui.tpl.appendChild(b);
          lazyThumb(b, function () { $('.adk-card__img', b).appendChild(tplThumb(it, z)); }, i);
        });
      });
    }).catch(failed);
  }
  function qrPathFn(text) {
    try { var q = window.ArdorQR.encode(text, 'M'); var p = window.ArdorQR.path(q, { quiet: 0, style: 'square', finder: 'square' }); return { d: p.d, size: p.size }; } catch (e) { return null; }
  }
  // Oct 18 2026 (Claude): draw template thumbnails only when their card scrolls into view (inside the drawer list),
  // one per idle moment, instead of all of them back to back. On phones drawing every thumbnail at once froze scrolling.
  function lazyThumb(card, draw, i) {
    var run = function () { if (card.__adkThumb) return; card.__adkThumb = true; try { draw(); } catch (e) { try { console.warn(e); } catch (x) {} } };
    var idle = window.requestIdleCallback ? function (f) { window.requestIdleCallback(f, { timeout: 400 }); } : function (f) { setTimeout(f, 16); };
    if (!('IntersectionObserver' in window)) { setTimeout(run, 30 + i * 25); return; }
    var io = new IntersectionObserver(function (ents) {
      for (var k = 0; k < ents.length; k++) { if (ents[k].isIntersecting) { io.disconnect(); idle(run); return; } }
    }, { root: card.closest('.abl-drawer__body, .adk-body') || null, rootMargin: '400px 0px' });
    io.observe(card);
  }
  function tplThumb(it, z) {
    var key = 't|' + it.id;
    if (!st.thumbs[key]) {
      var maxW = 260, maxH = 170, px = Math.min(maxW / z.Wi, maxH / z.Hi);
      var cv = el('canvas'); var sc = new fabric.StaticCanvas(cv, { width: Math.round(z.Wi * px), height: Math.round(z.Hi * px), enableRetinaScaling: false, renderOnAddRemove: false });
      sc.setViewportTransform([px, 0, 0, px, 0, 0]);
      sc.add(new fabric.ArdorBg({ left: 0, top: 0, width: z.Wi, height: z.Hi, ablBg: it.bg }));
      window.ArdorTPL.build(fabric, it, z.Wi, z.Hi, z.safe, { info: st.info, qrPath: qrPathFn }).forEach(function (o) { sc.add(o); });
      sc.renderAll();
      st.thumbs[key] = sc.toDataURL({ format: 'jpeg', quality: 0.85 });
      sc.dispose();
    }
    var im = new Image(); im.src = st.thumbs[key]; im.alt = ''; return im;
  }
  function designOnFace() { return objs().length > 0 || !!faceArt(); }
  function chooseTemplate(it) {
    if (designOnFace() && !(st.tpl && st.tplFace === curFace() && !st.tplDirty && !faceArt())) {
      st.pending = it; ui.confirm.hidden = false; ui.confirm.scrollIntoView({ block: 'nearest' });
      return;
    }
    applyTemplate(it, {});
  }
  // build the template for the current size; keepEdits: keep wording and colors the customer changed (by role and order)
  function applyTemplate(it, opt) {
    opt = opt || {};
    return Promise.all([K.ready(), loadTpl(), load('bg'), load('qr')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      return fontsReady(window.ArdorTPL.fonts(it));
    }).then(function () {
      var face = K.targetFace();
      var z = cfgSize();
      var old = fc.getObjects().slice();
      var keep = opt.keepEdits ? editsByRole(old, it.id) : null;
      var list = window.ArdorTPL.build(fabric, it, z.Wi, z.Hi, z.safe, { info: st.info, qrPath: qrPathFn });
      if (keep) restoreEdits(list, keep);
      st.rebuilding = true;
      K.setQuiet(true);
      fc.discardActiveObject();
      if (old.length) fc.remove.apply(fc, old);
      var bgSpec = (keep && keep.bg) || it.bg;
      fc.add(new fabric.ArdorBg({ left: 0, top: 0, width: z.Wi, height: z.Hi, ablBg: bgSpec }));
      list.forEach(function (o) { K.look(o); fc.add(o); });
      K.setQuiet(false);
      st.rebuilding = false;
      if (faceArt(face) && !opt.keepEdits) { try { API.setArt(face, null); } catch (e) {} }
      st.tpl = it; st.tplFace = face; st.tplVar = window.ArdorTPL.layoutKey ? window.ArdorTPL.layoutKey(it, z.Wi, z.Hi) : window.ArdorTPL.variant(z.Wi, z.Hi); st.tplDirty = !!(keep && keep.dirty);
      K.changed(true); K.sync(); K.syncProps(); fc.requestRenderAll();
      var ab = $('[data-adk-info-apply]', ui.tplPanel); if (ab) ab.hidden = false;
      if (phone()) K.closeDrawer();
      if (opt.reason === 'size') toast('We re-arranged your template for the new banner size.', 5000);
      else if (opt.reason !== 'info' && opt.reason !== 'link') toast('Template added. Tap any text to change the words, or drag things around.', 5000);
      track(opt.reason === 'size' ? 'template_refit' : 'template');
      qtRefreshSoon();
    }).catch(function (e) { st.rebuilding = false; try { K.setQuiet(false); } catch (x) {} failed(e); });
  }
  function roleKey(o, counts) { var r = (o.ablRole || 'x') + ':' + (o.ablKind || o.type); counts[r] = (counts[r] || 0) + 1; return r + ':' + counts[r]; }
  function editsByRole(old, id) {
    var out = { map: {}, bg: null, dirty: st.tplDirty }, counts = {};
    old.forEach(function (o) {
      if (o.ablKind === 'bg') { out.bg = o.ablBg; return; }
      if (o.ablTpl !== id) return;
      var k = roleKey(o, counts);
      out.map[k] = { text: o.ablKind === 'text' ? o.text : null, fill: o.fill, stroke: o.stroke, ablStroke: o.ablStroke, font: o.fontFamily, built: o.__adkText };
    });
    return out;
  }
  function restoreEdits(list, keep) {
    var counts = {};
    list.forEach(function (o) {
      var k = roleKey(o, counts), e = keep.map[k]; if (!e) return;
      if (o.ablKind === 'text') {
        var boxW = o.getScaledWidth();
        var changedByUser = e.text != null && e.built != null && e.text !== e.built;
        if (changedByUser) o.set('text', e.text);
        if (e.font && e.font !== o.fontFamily) o.set('fontFamily', e.font);
        o.set({ fill: e.fill });
        if (e.ablStroke != null) { o.set({ ablStroke: e.ablStroke, stroke: e.ablStroke ? e.stroke : null, strokeWidth: e.ablStroke ? o.fontSize * e.ablStroke * 0.012 : 0 }); }
        if (typeof o.initDimensions === 'function') o.initDimensions();
        var w = o.getScaledWidth(); if (w > boxW * 1.02 && boxW > 0) o.scale(o.scaleX * boxW / w);
      } else if (e.fill && typeof e.fill === 'string' && o.ablRole !== 'qr') { o.set({ fill: e.fill }); }
    });
  }
  // remember the wording each template text was built with (to tell customer edits from tokens)
  function markBuilt(list) { list.forEach(function (o) { if (o.ablKind === 'text') o.__adkText = o.text; }); }

  // banner size changed: re-arrange the template when the layout shape changes (wide, extra wide, square, tall)
  var lastSize = '';
  function watchSize() {
    if (!booted || !K || !API) return;
    var c; try { c = API.cfg(); } catch (e) { return; }
    var key = c.W + 'x' + c.H;
    if (key === lastSize) return;
    var first = !lastSize; lastSize = key;
    if (first) return;
    st.thumbs = {};
    if (ui.tplPanel && !ui.tplPanel.hidden) renderTemplates();
    if (!st.tpl || !fc || st.tplFace !== curFace()) return;
    var hasTpl = fc.getObjects().some(function (o) { return o.ablTpl === st.tpl.id; });
    if (!hasTpl) { st.tpl = null; return; }
    var v = window.ArdorTPL.layoutKey ? window.ArdorTPL.layoutKey(st.tpl, c.W * 12, c.H * 12) : window.ArdorTPL.variant(c.W * 12, c.H * 12);
    // same layout shape: the designer already keeps everything in place; only re-fit when the shape changes
    if (v === st.tplVar) return;
    setTimeout(function () { applyTemplate(st.tpl, { keepEdits: true, reason: 'size' }); }, 80);
  }

  // ---------- Background ----------
  function buildBgPanel() {
    var p = panel('background', 'Background',
      '<p class="abl-help" data-adk-bg-note>Pick a color, gradient, pattern, texture or scene for the whole banner.</p>' +
      '<div class="adk-chips" data-adk-bg-cats></div>' +
      '<div class="adk-bg-custom"><label class="abl-color"><input type="color" value="#ffffff" aria-label="Pick any background color" data-adk-bg-color><span>Any color</span></label><button type="button" class="adk-btn adk-btn--ghost" data-adk-bg-none>No background</button></div>' +
      '<div class="adk-grid adk-grid--bg" data-adk-bg><p class="abl-help">Loading...</p></div>');
    ui.bgPanel = p; ui.bgGrid = $('[data-adk-bg]', p); ui.bgCats = $('[data-adk-bg-cats]', p); ui.bgNote = $('[data-adk-bg-note]', p);
    $('[data-adk-bg-color]', p).addEventListener('input', function (e) { setBackground({ t: 'solid', c: e.target.value }, true); });
    $('[data-adk-bg-color]', p).addEventListener('change', function (e) { var from = st.liveFrom; st.liveFrom = null; autoContrast({ t: 'solid', c: e.target.value }, from); K.changed(true); });
    $('[data-adk-bg-none]', p).addEventListener('click', function () { removeBackground(); });
  }
  function openBackground() {
    Promise.all([K.ready(), load('bg')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      var G = window.ArdorBG;
      if (!ui.bgCats.children.length) {
        G.cats.forEach(function (c) { var b = el('button', 'adk-chip', esc(c)); b.type = 'button'; b.setAttribute('data-c', c); ui.bgCats.appendChild(b); });
        ui.bgCats.addEventListener('click', function (e) { var b = e.target.closest('[data-c]'); if (!b) return; st.bgCat = b.getAttribute('data-c'); renderBg(); });
      }
      renderBg();
    }).catch(failed);
  }
  function renderBg() {
    var G = window.ArdorBG, art = faceArt();
    $$('[data-c]', ui.bgCats).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c') === st.bgCat ? 'true' : 'false'); });
    ui.bgNote.innerHTML = art ? '<b>Your uploaded artwork covers the banner.</b> Colors here fill any space around your artwork. To use a gradient, pattern, texture or scene, remove your artwork first (Artwork panel).' : 'Pick a color, gradient, pattern, texture or scene for the whole banner. Your text and clipart stay on top.';
    ui.bgGrid.textContent = '';
    var z = cfgSize(), ar = clamp(z.Wi / z.Hi, 0.5, 3);
    G.gallery.filter(function (g) { return g.cat === st.bgCat; }).forEach(function (g) {
      var b = el('button', 'adk-card adk-card--bg'); b.type = 'button'; b.title = g.name; b.setAttribute('aria-label', 'Background: ' + g.name);
      var dis = art && g.spec.t !== 'solid'; if (dis) b.disabled = true;
      var w = 120, h = Math.round(w / ar);
      try { var t = G.thumb(g.spec, w, h); t.className = 'adk-bg-thumb'; b.appendChild(t); } catch (e) {}
      b.appendChild(el('span', 'adk-card__name', esc(g.name)));
      b.addEventListener('click', function () { setBackground(g.spec, false); });
      ui.bgGrid.appendChild(b);
    });
  }
  function setBackground(spec, live) {
    Promise.all([K.ready(), load('bg')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      var face = K.targetFace(), art = faceArt(face);
      if (art) { // behind uploaded artwork only a plain color is possible
        if (spec.t !== 'solid') { toast('Remove your uploaded artwork first to use this background.', 5000); return; }
        art.bg = spec.c; try { API.renderArtOnly(); } catch (e) {}
        var inp = document.querySelector('[data-abb-bg]'); if (inp) inp.value = spec.c;
        return;
      }
      var z = cfgSize(), b = bgObj(), prev = b ? b.ablBg : null;
      if (b) { b.ablBg = spec; b.set({ dirty: true }); fc.requestRenderAll(); if (!live) K.changed(true); else { try { API.renderArtOnly(); } catch (e) {} } }
      else {
        st.rebuilding = true; K.setQuiet(true);
        b = new fabric.ArdorBg({ left: 0, top: 0, width: z.Wi, height: z.Hi, ablBg: spec });
        fc.add(b); fc.moveTo(b, 0);
        K.setQuiet(false); st.rebuilding = false;
        K.changed(!live);
      }
      if (!live) autoContrast(spec, prev); else if (!st.liveFrom) st.liveFrom = prev || { t: 'solid', c: '#FFFFFF' };
      if (!live && st.liveFrom) { st.liveFrom = null; }
      K.sync(); fc.requestRenderAll();
      if (!live) track('background');
    }).catch(failed);
  }
  // after a background change, flip plain black or white text that would disappear (only text sitting right on the background)
  function lum(hex) { var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim()); if (!m) return 0.5; var n = parseInt(m[1], 16); return (0.299 * (n >> 16 & 255) + 0.587 * (n >> 8 & 255) + 0.114 * (n & 255)) / 255; }
  function overShape(t, list) {
    var i = list.indexOf(t), c = t.getCenterPoint();
    for (var j = i - 1; j >= 0; j--) { var o = list[j]; if (o.ablKind === 'bg') continue; var r = o.getBoundingRect(true, true); if (c.x >= r.left && c.x <= r.left + r.width && c.y >= r.top && c.y <= r.top + r.height) return true; }
    return false;
  }
  function autoContrast(spec, prevSpec) {
    var G = window.ArdorBG; if (!G) return;
    var dark = false, was = false; try { dark = G.isDark(spec); was = prevSpec ? G.isDark(prevSpec) : false; } catch (e) { return; }
    if (dark === was) return;
    var list = objs(), changedAny = false;
    list.forEach(function (o) {
      if (o.ablKind !== 'text' || typeof o.fill !== 'string' || overShape(o, list)) return;
      var L = lum(o.fill);
      if (dark && L < 0.22) { o.set('fill', '#FFFFFF'); changedAny = true; }
      if (!dark && L > 0.85) { o.set('fill', '#16161B'); changedAny = true; }
    });
    if (changedAny) fc.requestRenderAll();
  }
  function removeBackground() {
    var art = faceArt();
    if (art) { art.bg = '#FFFFFF'; try { API.renderArtOnly(); } catch (e) {} return; }
    var b = bgObj(); if (!b) return;
    fc.remove(b); K.changed(true); fc.requestRenderAll();
  }

  // ---------- QR code ----------
  var QR_TYPES = [
    ['url', 'Website', [['url', 'Website address', 'url', 'yourwebsite.com']]],
    ['tel', 'Phone call', [['tel', 'Phone number', 'tel', '(555) 555-5555']]],
    ['sms', 'Text message', [['sms', 'Phone number', 'tel', '(555) 555-5555'], ['body', 'Message (optional)', 'text', '']]],
    ['email', 'Email', [['to', 'Email address', 'email', 'you@yourbusiness.com'], ['subject', 'Subject (optional)', 'text', '']]],
    ['wifi', 'Wi-Fi', [['ssid', 'Network name', 'text', ''], ['pass', 'Password', 'text', ''], ['enc', 'Security', 'select:WPA=WPA / WPA2,WEP=WEP,nopass=No password', 'WPA']]],
    ['vcard', 'Contact card', [['name', 'Name', 'text', ''], ['org', 'Business', 'text', ''], ['phone', 'Phone', 'tel', ''], ['email', 'Email', 'email', ''], ['url', 'Website', 'url', '']]],
    ['text', 'Plain text', [['text', 'Text', 'textarea', '']]]
  ];
  function buildQrPanel() {
    var opts = QR_TYPES.map(function (t) { return '<option value="' + t[0] + '">' + t[1] + '</option>'; }).join('');
    var p = panel('qr', 'QR code',
      '<p class="abl-help">Make a QR code people can scan from your banner. It prints sharp at any size.</p>' +
      '<label class="adk-field"><span>What should it open?</span><select class="abl-input" data-adk-qr-type>' + opts + '</select></label>' +
      '<div data-adk-qr-fields></div>' +
      '<div class="adk-two"><label class="adk-field"><span>Style</span><select class="abl-input" data-adk-qr-style><option value="square">Square</option><option value="rounded">Rounded</option></select></label>' +
      '<label class="adk-field"><span>Corners</span><select class="abl-input" data-adk-qr-finder><option value="square">Square</option><option value="rounded">Rounded</option></select></label></div>' +
      '<div class="adk-two"><label class="adk-field"><span>Code color</span><span class="abl-color"><input type="color" value="#000000" data-adk-qr-fg aria-label="QR code color"></span></label>' +
      '<label class="adk-field"><span>Behind the code</span><span class="abl-color"><input type="color" value="#ffffff" data-adk-qr-bg aria-label="QR code background color"></span></label></div>' +
      '<p class="adk-warn" data-adk-qr-warn hidden></p>' +
      '<div class="adk-qr-preview" data-adk-qr-preview></div>' +
      '<button type="button" class="adk-btn adk-btn--wide" data-adk-qr-add>Add QR code to my banner</button>' +
      '<p class="abl-help adk-small" data-adk-qr-size></p>' +
      '<p class="abl-help adk-small">Tip: test it with your phone camera on the proof before you order. Make the code about 1 in wide for every 10 in of scanning distance (about 12 in wide for people 10 ft away).</p>');
    ui.qrPanel = p; ui.qrType = $('[data-adk-qr-type]', p); ui.qrFields = $('[data-adk-qr-fields]', p);
    ui.qrPrev = $('[data-adk-qr-preview]', p); ui.qrWarn = $('[data-adk-qr-warn]', p); ui.qrAdd = $('[data-adk-qr-add]', p); ui.qrSize = $('[data-adk-qr-size]', p);
    ui.qrType.addEventListener('change', function () { qrFields(); qrPreview(); });
    ['[data-adk-qr-style]', '[data-adk-qr-finder]', '[data-adk-qr-fg]', '[data-adk-qr-bg]'].forEach(function (s) { $(s, p).addEventListener('input', qrPreview); });
    ui.qrAdd.addEventListener('click', addQr);
    qrFields();
  }
  function qrFields(vals) {
    var t = QR_TYPES.filter(function (x) { return x[0] === ui.qrType.value; })[0];
    vals = vals || {};
    ui.qrFields.textContent = '';
    t[2].forEach(function (f) {
      var lab = el('label', 'adk-field', '<span>' + esc(f[1]) + '</span>'), inp;
      if (f[2] === 'textarea') { inp = el('textarea', 'abl-input abl-textarea'); inp.rows = 3; }
      else if (f[2].indexOf('select:') === 0) {
        inp = el('select', 'abl-input');
        f[2].slice(7).split(',').forEach(function (o) { var kv = o.split('='), op = el('option'); op.value = kv[0]; op.textContent = kv[1]; inp.appendChild(op); });
      } else { inp = el('input', 'abl-input'); inp.type = f[2] === 'url' ? 'text' : f[2]; if (f[2] === 'url') inp.setAttribute('inputmode', 'url'); }
      inp.setAttribute('data-adk-qf', f[0]);
      if (f[3] && inp.tagName !== 'SELECT') inp.placeholder = f[3];
      var v = vals[f[0]] != null ? vals[f[0]] : (f[0] === 'url' && ui.qrType.value === 'url' ? st.info.web : (f[0] === 'tel' ? st.info.phone : ''));
      if (inp.tagName === 'SELECT') inp.value = vals[f[0]] || f[3]; else inp.value = v || '';
      inp.addEventListener('input', qrPreview);
      lab.appendChild(inp); ui.qrFields.appendChild(lab);
    });
  }
  function qrValues() { var v = {}; $$('[data-adk-qf]', ui.qrFields).forEach(function (i) { v[i.getAttribute('data-adk-qf')] = i.value.replace(/^\s+|\s+$/g, ''); }); return v; }
  function qrPayload(type, v) {
    var P = window.ArdorQR.payload;
    if (type === 'url') return v.url ? P.url(v.url) : '';
    if (type === 'tel') return v.tel ? P.tel(v.tel.replace(/[^\d+]/g, '')) : '';
    if (type === 'sms') return v.sms ? P.sms(v.sms.replace(/[^\d+]/g, ''), v.body || '') : '';
    if (type === 'email') return v.to ? P.email(v.to, v.subject || '', '') : '';
    if (type === 'wifi') return v.ssid ? P.wifi(v.ssid, v.pass || '', v.enc || 'WPA', false) : '';
    if (type === 'vcard') return (v.name || v.org) ? P.vcard({ name: v.name, org: v.org, phone: v.phone, email: v.email, url: v.url }) : '';
    return v.text ? P.text(v.text) : '';
  }
  function qrSettings() {
    var p = ui.qrPanel;
    return { type: ui.qrType.value, v: qrValues(), style: $('[data-adk-qr-style]', p).value, finder: $('[data-adk-qr-finder]', p).value, fg: $('[data-adk-qr-fg]', p).value, bg: $('[data-adk-qr-bg]', p).value };
  }
  function openQr() {
    load('qr').then(function () {
      var a = fc && fc.getActiveObject();
      if (a && a.ablKind === 'qr' && a.ablQr) { loadQrSettings(a); }
      else { st.qrEdit = null; ui.qrAdd.textContent = 'Add QR code to my banner'; }
      qrPreview();
    }).catch(failed);
  }
  function loadQrSettings(o) {
    var s = null; try { s = typeof o.ablQr === 'string' ? JSON.parse(o.ablQr) : o.ablQr; } catch (e) {}
    if (!s || !s.type) return;
    st.qrEdit = o;
    ui.qrType.value = s.type; qrFields(s.v || {});
    $('[data-adk-qr-style]', ui.qrPanel).value = s.style || 'square';
    $('[data-adk-qr-finder]', ui.qrPanel).value = s.finder || 'square';
    $('[data-adk-qr-fg]', ui.qrPanel).value = s.fg || '#000000';
    $('[data-adk-qr-bg]', ui.qrPanel).value = s.bg || '#ffffff';
    ui.qrAdd.textContent = 'Update this QR code';
  }
  function qrPreview() {
    if (!window.ArdorQR || !ui.qrPrev) return;
    var s = qrSettings(), data = qrPayload(s.type, s.v), Q = window.ArdorQR;
    ui.qrWarn.hidden = true;
    if (!data) { ui.qrPrev.innerHTML = '<p class="abl-help">Fill in the details above to see your code.</p>'; ui.qrAdd.disabled = true; return; }
    try {
      var q = Q.encode(data, 'M');
      ui.qrPrev.innerHTML = Q.svg(q, { fg: s.fg, bg: s.bg, px: 180, quiet: 4, style: s.style, finder: s.finder });
      ui.qrAdd.disabled = false;
      if (!Q.ok(s.fg, s.bg)) { ui.qrWarn.textContent = 'Phones scan best with a dark code on a light background. These colors may not scan.'; ui.qrWarn.hidden = false; }
    } catch (e) { ui.qrPrev.innerHTML = '<p class="adk-warn">That is too long for a QR code. Please shorten it.</p>'; ui.qrAdd.disabled = true; }
    qrSizeNote();
  }
  function qrSizeNote() {
    var o = st.qrEdit || (fc && fc.getActiveObject());
    if (!ui.qrSize || !window.ArdorQR) return;
    if (o && o.ablKind === 'qr') { var w = o.getScaledWidth(); ui.qrSize.textContent = 'On your banner this code is ' + (Math.round(w * 10) / 10) + ' in wide: easy to scan from about ' + Math.round(window.ArdorQR.scanDistanceFt(w)) + ' ft away.'; }
    else ui.qrSize.textContent = '';
  }
  function makeQrGroup(s, data, sizeIn) {
    var Q = window.ArdorQR, q = Q.encode(data, 'M');
    var p = Q.path(q, { quiet: 0, style: s.style, finder: s.finder });
    var code = new fabric.Path(p.d, { fill: s.fg, fillRule: 'evenodd', stroke: null, strokeWidth: 0, originX: 'center', originY: 'center' });
    var u = (sizeIn * 0.84) / Math.max(code.width || 1, code.height || 1);
    code.set({ scaleX: u, scaleY: u, left: 0, top: 0 });
    var r = sizeIn * 0.06;
    var plate = new fabric.Rect({ width: sizeIn, height: sizeIn, rx: r, ry: r, fill: s.bg, originX: 'center', originY: 'center', left: 0, top: 0, strokeWidth: 0 });
    var g = new fabric.Group([plate, code], { originX: 'center', originY: 'center', ablKind: 'qr', ablLabel: 'QR code', ablRole: 'qr', ablQr: JSON.stringify(s), lockScalingFlip: true });
    return g;
  }
  function addQr() {
    Promise.all([K.ready(), load('qr')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      var s = qrSettings(), data = qrPayload(s.type, s.v);
      if (!data) return;
      K.targetFace();
      var z = cfgSize(), sz = Math.min(z.safe.h * 0.46, z.safe.w * 0.26, 30);
      var old = st.qrEdit && fc.getObjects().indexOf(st.qrEdit) >= 0 ? st.qrEdit : null;
      if (old) sz = old.getScaledWidth();
      var g = makeQrGroup(s, data, sz);
      K.look(g);
      if (old) {
        g.set({ left: old.left, top: old.top, angle: old.angle || 0 });
        var idx = fc.getObjects().indexOf(old);
        K.setQuiet(true); fc.remove(old); fc.insertAt(g, idx); K.setQuiet(false);
        fc.setActiveObject(g); g.setCoords(); K.changed(true); K.syncProps();
      } else {
        g.set({ left: z.safe.x + z.safe.w - sz / 2 - z.safe.w * 0.04, top: z.safe.y + z.safe.h / 2 });
        if (z.safe.w / z.safe.h < 1) g.set({ left: z.Wi / 2, top: z.safe.y + z.safe.h - sz / 2 - z.safe.h * 0.04 });
        K.place(g);
      }
      st.qrEdit = g; ui.qrAdd.textContent = 'Update this QR code';
      qrSizeNote();
      // a template's QR spot placeholder is no longer needed
      var ph = fc.getObjects().filter(function (o) { return o.ablRole === 'qr' && o.ablKind !== 'qr'; });
      if (ph.length && !old) { K.setQuiet(true); fc.remove.apply(fc, ph); K.setQuiet(false); K.changed(true); }
      track('qr_' + s.type);
    }).catch(failed);
  }

  // ---------- properties panel extras (QR code, logo spot) ----------
  function buildPropsExtras() {
    var props = K.ui().props; if (!props) return;
    var qrBox = el('div', 'adk-props-qr', '<p class="abl-help" data-adk-pqr-size></p><button type="button" class="abl-done" data-adk-pqr-edit>Edit QR code</button>');
    qrBox.setAttribute('data-abl-p', 'qr'); qrBox.hidden = true;
    var logoBox = el('div', 'adk-props-logo', '<p class="abl-help">This is a spot for your logo.</p><label class="adk-btn adk-btn--wide adk-file">Add my logo<input type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" data-adk-logo-file hidden></label>');
    logoBox.hidden = true;
    var head = $('.abl-props__head', props);
    if (head && head.nextSibling) props.insertBefore(logoBox, head.nextSibling); else props.appendChild(logoBox);
    props.appendChild(qrBox);
    ui.pQr = qrBox; ui.pLogo = logoBox;
    $('[data-adk-pqr-edit]', qrBox).addEventListener('click', function () { if (ui.tQr) ui.tQr.click(); });
    var tt = K.ui().pTitle;
    if (tt && window.MutationObserver) new MutationObserver(function () {
      var o = fc && fc.getActiveObject(); if (!o) return;
      var want = o.ablKind === 'qr' ? 'QR code' : (o.ablRole === 'logo' ? 'Logo spot' : '');
      if (want && tt.textContent !== want) tt.textContent = want;
    }).observe(tt, { childList: true, characterData: true, subtree: true });
    $('[data-adk-logo-file]', logoBox).addEventListener('change', function (e) { var f = e.target.files && e.target.files[0]; e.target.value = ''; if (f) addLogo(f); });
  }
  function selSync() {
    var o = fc && fc.getActiveObject(), u = K.ui();
    if (ui.pLogo) ui.pLogo.hidden = !(o && o.ablRole === 'logo');
    if (o && o.ablKind === 'qr' && u && u.pTitle) {
      u.pTitle.textContent = 'QR code';
      var w = o.getScaledWidth(), sz = $('[data-adk-pqr-size]', ui.pQr);
      if (sz && window.ArdorQR) sz.textContent = Math.round(w * 10) / 10 + ' in wide. Easy to scan from about ' + Math.round(window.ArdorQR.scanDistanceFt(w)) + ' ft.';
      if (ui.qrPanel && !ui.qrPanel.hidden) { loadQrSettings(o); qrPreview(); }
    }
    if (o && o.ablRole === 'logo' && u && u.pTitle) u.pTitle.textContent = 'Logo spot';
  }
  function addLogo(file) {
    if (!/^image\//.test(file.type) || file.size > 25 * 1024 * 1024) { toast('Please pick a PNG, JPG, WebP or SVG image under 25 MB.', 5000); return; }
    var rd = new FileReader();
    rd.onload = function () {
      var img = new Image();
      img.onload = function () {
        var max = 2400, w = img.naturalWidth || 800, h = img.naturalHeight || 800, k = Math.min(1, max / Math.max(w, h));
        var cv = el('canvas'); cv.width = Math.max(1, Math.round(w * k)); cv.height = Math.max(1, Math.round(h * k));
        cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
        var url = cv.toDataURL(/png|svg|webp/.test(file.type) ? 'image/png' : 'image/jpeg', 0.92);
        fabric.Image.fromURL(url, function (im) {
          var spots = fc.getObjects().filter(function (o) { return o.ablRole === 'logo'; });
          var box = null;
          spots.forEach(function (o) { var r = o.getBoundingRect(true, true); if (!box) box = { l: r.left, t: r.top, r: r.left + r.width, b: r.top + r.height }; else { box.l = Math.min(box.l, r.left); box.t = Math.min(box.t, r.top); box.r = Math.max(box.r, r.left + r.width); box.b = Math.max(box.b, r.top + r.height); } });
          var z = cfgSize();
          if (!box) box = { l: z.Wi / 2 - z.safe.w * 0.15, t: z.Hi / 2 - z.safe.h * 0.2, r: z.Wi / 2 + z.safe.w * 0.15, b: z.Hi / 2 + z.safe.h * 0.2 };
          var bw = box.r - box.l, bh = box.b - box.t, s = Math.min(bw / im.width, bh / im.height);
          im.set({ originX: 'center', originY: 'center', left: box.l + bw / 2, top: box.t + bh / 2, scaleX: s, scaleY: s, ablKind: 'image', ablLabel: 'Your logo' });
          K.look(im);
          K.setQuiet(true); if (spots.length) fc.remove.apply(fc, spots); K.setQuiet(false);
          K.place(im);
          track('logo');
        });
      };
      img.onerror = function () { toast('We could not read that image. Please try a PNG or JPG.', 5000); };
      img.src = rd.result;
    };
    rd.readAsDataURL(file);
  }

  // wrap ArdorTPL.build so every built text remembers its original wording
  function wrapBuild() {
    var T = window.ArdorTPL; if (!T || T.__adkWrapped) return;
    var b = T.build; T.build = function () { var r = b.apply(T, arguments); markBuilt(r); return r; }; T.__adkWrapped = true;
  }
  var _lt = loadTpl; loadTpl = function () { return _lt().then(function (x) { wrapBuild(); return x; }); };

  // before Add to cart: warn once when sample words or empty logo / QR spots are still on the banner
  var SAMPLE = /YOUR BUSINESS|\(555\) 555-5555|YOURWEBSITE\.COM|YOUR TAGLINE HERE|MONTH DAY|YOUR ADDRESS, CITY|YOUR LOGO|YOUR QR CODE|TEAM NAME|GRADUATE NAME|ADD A HEADING|ADD A SUBHEADING|ADD A LITTLE BIT OF BODY TEXT/i;
  function leftovers() {
    if (!K || !fc) return [];
    var out = [];
    ['front', 'back'].forEach(function (f) {
      (K.objectsFor(f) || []).forEach(function (o) {
        if (o.ablKind === 'text' && SAMPLE.test(String(o.text || '').replace(/\s+/g, ' '))) out.push(String(o.text).replace(/\s+/g, ' ').slice(0, 40));
        else if (o.ablRole === 'logo' && o.ablKind !== 'text' && out.indexOf('YOUR LOGO') < 0) out.push('YOUR LOGO');
      });
    });
    return out.filter(function (v, i, a) { return a.indexOf(v) === i; });
  }
  var cartOk = 0;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-abb-add], [data-abb-add-d], [data-abb-add-m]');
    if (!b || Date.now() - cartOk < 60000) return;
    var left = leftovers();
    if (!left.length) return;
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    toast('Your banner still shows sample text: ' + left.slice(0, 4).join(', ') + (left.length > 4 ? '...' : '') + '. Change or delete it before you order.', 12000, { label: 'Order anyway', run: function () { cartOk = Date.now(); b.click(); } });
    track('sample_text_warning');
  }, true);

  window.ArdorDesignerKit = { v: 1, applyTemplate: function (id) { return loadTpl().then(function () { return applyTemplate(window.ArdorTPL.get(id), {}); }); }, setBackground: setBackground, state: st };
  if (window.ArdorBannerLayers && window.ArdorBannerLayers.kit) boot();
  else document.addEventListener('ardor:layers-kit', boot);
  var tries = 0, t = setInterval(function () { if (booted || ++tries > 80) { clearInterval(t); return; } boot(); }, 250);
})();
